/**
 * Strips HTML tags from a string, returning clean text
 */
type StrippedHtml<T> = T extends string ? string : T

function stripHtmlTags<T extends string | null | undefined>(htmlString: T): StrippedHtml<T>
function stripHtmlTags(htmlString: string | null | undefined): string | null | undefined {
  if (!htmlString) return htmlString
  return htmlString.replace(/(<([^>]+)>)/gi, '')
}

export default stripHtmlTags
